import { call, put } from 'redux-saga/effects';
import { api, showErrorNotification } from '@med-fe/util';
import { fetchUserPositionsSuccess, fetchUserPositionsFailed } from './user-actions';

export function* fetchUserPositionsStartWorker({ payload }): Generator {
  try {
    const url = `/employee/positions/${payload}`;
    const data = yield call(api.get, url, true, true);
    yield put(fetchUserPositionsSuccess(data));
  } catch (e) {
    console.log(e, 'error--');
    yield put(fetchUserPositionsFailed(e));
    showErrorNotification(null, e);
  }
}
